import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dcf-calculator',
  component: () => import('../../routes/DCF.svelte'),
  card: {
    id: 'dcf-calculator',
    title: 'DCF Calculator',
    description: 'Estimate intrinsic business value using Discounted Cash Flow analysis. Project future cash flows, apply a terminal value, and discount to present day.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dcf-calculator',
    category: 'Business',
  },
  seo: {
    title: 'DCF Calculator – Discounted Cash Flow Business Valuation',
    description: 'Free DCF calculator to estimate intrinsic business value. Project future cash flows, apply terminal growth, and discount to present value. Used by investors for stock valuation.',
  },
};

export default meta;
